<template>
  <div name="hrms15e-group">
    <div class="evaluation-header clearfix cursor-pointer border-top-color-skin" @click="toggleGroup()">
      <div class="col-xs-8 clear-padding">
        <div class="col-xs-12 col-md-6 clear-padding">{{ labels['HRAP31EC4']['110'] }} {{ dataGroup.numgrup }}</div>
        <div class="col-xs-12 col-md-6 clear-padding evaluation-title">{{ dataGroup.desc_numgrup }}</div>
      </div>
      <div class="col-xs-4 clear-padding evaluation-score">{{ calResultScore(dataGroup) }}/{{ calTotalScore(dataGroup) }}</div>
    </div>
    <div class="evaluation-body" v-show="groupDisp">
      <div class="evaluation-section clearfix">
        <template v-for="(item, index) in dataGroup.numitem">
          <item :disabled="disabled"
                :dataGroup="dataGroup"
                :item="item"
                :choices="item.choices"
                :labels="labels"
                :name="name"
                :labelsHrms15e="labelsHrms15e" />
        </template>
      </div>
      <form class="form-horizontal mgb-10">
        <div class="form-group margin-b-5">
          <label class="col-md-3 control-label">{{ labels['HRAP31EC4']['225'] }}</label>
          <div class="col-md-8">
            <textarea class="form-control"
                      v-model="dataGroup.desimpro"
                      :disabled="disabled"
                      maxlength="100"
                      v-validate="'max:100'"
                      data-vv-name="desimpro"
                      :has-error="errors.has('desimpro')"></textarea>
            <div class="text-error" v-show="errors.has('desimpro')">{{errors.first('desimpro')}}</div>
            <div class="remark-limit-character">{{ dispLimitLabel(100) }}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import item from 'components/hrms15e/item2'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hrms15e-group',
  data () {
    return {
      groupDisp: false
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Object
    },
    dataGroup: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    labelsHrms15e: {
      type: Object
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    toggleGroup () {
      this.groupDisp = !this.groupDisp
    },
    calResultScore (dataGroup) {
      let groupQtyscor = dataGroup.numitem.map((item) => {
        return parseFloat(item.score)
      }).reduce((a, b) => {
        return parseFloat(a) + parseFloat(b)
      })
      this.$set(dataGroup, 'qtyscor', Number.parseFloat(groupQtyscor).toFixed(2))
      return Number.parseFloat(groupQtyscor).toFixed(2)
    },
    calTotalScore (dataGroup) {
      let groupQtyfscor = dataGroup.numitem.map((item) => {
        return parseFloat(item.qtyfscor)
      }).reduce((a, b) => {
        return parseFloat(a) + parseInt(b)
      })
      this.$set(dataGroup, 'qtyfscor', Number.parseFloat(groupQtyfscor).toFixed(2))
      return Number.parseFloat(groupQtyfscor).toFixed(2)
    }
  },
  components: {
    item
  }
}
</script>



// WEBPACK FOOTER //
// group2.vue?44411092